//import React, { Fragment } from "react";
import {
  OuterContainer,
  Container,
  FormContainer,
  TableContainer,
  TableWrapper,
  CardContainer,
  CardWrapper,
  BadgeHeading,
  BadgeImage,
  Value,
  Label,
} from "../component/styles";
import { PrimaryCTAButton } from "../../../common/Buttons";
import { useLocation } from "@reach/router";
import HostService from "../../../../services/HostService";
import React, { Fragment, useState, useEffect } from "react";
import { useSnackbar } from "notistack";
import { getErrorMessage } from "../../../../helpers/functions";
import useLoader from "../../../../hooks/useLoader";
const Atendees = ({
  eventId,
  hostId,
  filterOption,
  attendees,
  setAttendees,
  registrationDetails,
  setRegistrationDetails,
  reportAttendees,
  setReportAttendees,
  reportRegistered,
  setReportRegistered,
}) => {
  //alert(eventId);
  const location = useLocation();
  const [trigger, setTrigger] = useState(false);
  //const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const { setLoader } = useLoader();

  useEffect(() => {
    async function eventAllRegistrationInfo() {
      try {
        const response = await HostService.eventAllRegistrationInfoNew(eventId);
        setReportRegistered(response.registeredViewerDetails);
        setReportAttendees(response.attendeeViewerDetails);
      } catch (error) {
        const message = getErrorMessage(error);
        enqueueSnackbar(message, {
          variant: "error",
        });
      } finally {
        setTrigger(false);
      }
    }
    eventAllRegistrationInfo(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger]);
  const badges = [
    {
      value: attendees?.noOfRegisteredViewer
        ? attendees?.noOfRegisteredViewer
        : 0,
      label: "Total Registration",
      description: "Total number of people registered for this conference",
      icon: require("../../../../assets/images/Icons for EM-01.svg"),
      props: {
        onClick: () => {
          downloadAttendeeDetails({
            hostId: hostId,
            attendeesDetail: reportRegistered,
          });
        },
      },
    },
    {
      value: attendees?.noOfAttendees ? attendees?.noOfAttendees : 0,
      label: "Total Viewers",
      description: "Total number of viewers",
      icon: require("../../../../assets/images/Host Asset 12.svg"),
    },
    {
      value: attendees?.noOfLiveViewers ? attendees?.noOfLiveViewers : 0,
      label: "Total Live Viewers",
      description: "Total number of live viewers",
      icon: require("../../../../assets/images/Host Asset 7.svg"),
      props: {
        onClick: () => {
          downloadAttendeeDetails({
            attendeesDetail: reportAttendees,
          });
        },
      },
    },
  ];

  const badges_past = [
    {
      value: attendees?.noOfRegisteredViewer
        ? attendees?.noOfRegisteredViewer
        : 0,
      label: "Total Registration",
      description: "Total number of people registered for this conference",
      icon: require("../../../../assets/images/Icons for EM-01.svg"),
      props: {
        onClick: () => {
          downloadAttendeeDetails({
            hostId: hostId,
            attendeesDetail: reportRegistered,
          });
        },
      },
    },
    {
      value: attendees?.noOfAttendees ? attendees?.noOfAttendees : 0,
      label: "Total Viewers",
      description: "Total number of viewers",
      icon: require("../../../../assets/images/Icons for EM-02.svg"),
      props: {
        onClick: () => {
          downloadAttendeeDetails({
            attendeesDetail: reportAttendees,
          });
        },
      },
    },
  ];

  const downloadAttendeeDetails = async (payload) => {
    try {
      setLoader({ state: true, message: "Downloading viewer detais" });
      const response = await HostService.downloadAttendeeDetailsNew(
        location?.state?.eventId,
        payload,
      );
      if (response) {
        const blob = new Blob([response], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        // Create a link and trigger a download
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `AttendeesDetail-EventId-${
          location?.state?.eventId
        }-${new Date().toLocaleDateString("en-GB")}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (err) {
    } finally {
      setLoader({ state: false });
    }
  };

  return (
    <Fragment>
      {" "}
      <OuterContainer>
        <Container>
          <FormContainer>
            <TableContainer>
              <TableWrapper>
                <CardContainer>
                  {location?.state?.past || location?.state?.upcoming
                    ? badges_past.map((badge) => (
                        <CardWrapper>
                          <BadgeHeading>{badge.label}</BadgeHeading>
                          <BadgeImage src={badge.icon} />
                          <Value>{badge.value}</Value>
                          <Label>{badge.description}</Label>
                          <PrimaryCTAButton
                            style={{ width: "auto" }}
                            onClick={() => badge.props.onClick()}
                          >
                            Download
                          </PrimaryCTAButton>
                        </CardWrapper>
                      ))
                    : badges.map((badge) => (
                        <CardWrapper>
                          <BadgeHeading>{badge.label}</BadgeHeading>
                          <BadgeImage src={badge.icon} />
                          <Value>{badge.value}</Value>
                          <Label>{badge.description}</Label>
                          <PrimaryCTAButton
                            style={{ width: "auto" }}
                            onClick={() => badge.props.onClick()}
                          >
                            Download
                          </PrimaryCTAButton>
                        </CardWrapper>
                      ))}
                  {/* <div style={{ justifyContent: "center" }}>
                    <PrimaryCTAButton
                      style={{ width: "auto" }}
                      onClick={downloadAttendeeDetails}
                    >
                      Download
                    </PrimaryCTAButton>
                  </div> */}
                </CardContainer>
              </TableWrapper>
            </TableContainer>
          </FormContainer>
        </Container>
      </OuterContainer>
    </Fragment>
  );
};

export default Atendees;
